import "../../../assets/fa-icons/css/fontawesome.css";
import "../../../assets/fa-icons/css/sharp-regular.css";
import { BaseProps } from "./button-base-props.ts";
import { getButtonStyles } from "./button-utility.ts";

interface ButtonProps extends BaseProps {
  disabled?: boolean;
  loading?: boolean;
  loadingLabel?: string;
  type?: "submit" | "reset" | "button" | undefined;
  className?: string;
}

// loading icon
const loadingIcon = <i className="fa-sharp fa-regular fa-spinner-third text-base animate-spin" />;

export const Button = ({
  label,
  color = "primary",
  style = "solid",
  disabled = false,
  loading = false,
  loadingLabel,
  type,
  onClick,
  renderLeadingIcon,
  className,
}: ButtonProps) => {
  const handleButtonClick = () => {
    if (onClick) {
      onClick();
    }
  };

  if (loading) {
    label = loadingLabel ?? label;
  }

  const icon = renderLeadingIcon ? renderLeadingIcon() : null;

  const buttonClasses = [getButtonStyles(style, color, disabled, loading), className].filter(Boolean).join(" ");

  return (
    <button
      className={buttonClasses}
      onClick={handleButtonClick}
      disabled={disabled}
      aria-disabled={disabled}
      type={type}
    >
      {loading && loadingIcon}
      {icon} {label}
    </button>
  );
};
